import CollectionActions from "./CollectionActions";

export default CollectionActions;
